import { render, staticRenderFns } from "./cookie.vue?vue&type=template&id=9a7aeab4&scoped=true"
import script from "./cookie.vue?vue&type=script&lang=js"
export * from "./cookie.vue?vue&type=script&lang=js"
import style0 from "./cookie.vue?vue&type=style&index=0&id=9a7aeab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7aeab4",
  null
  
)

export default component.exports